import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

/**
 * TODO: Migrate to use BaseCard
 */
export const ChartCard: FC<{
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}> = ({ title, subtitle, actions, className, children }) => {
  const hasHeader = title != null || actions != null || subtitle != null;
  return (
    <div
      className={twMerge(
        "rounded-md bg-white px-4 pt-3 pb-4 shadow-sm ring-1 ring-black/5",
        className,
      )}
    >
      {hasHeader ? (
        <div className="mb-3 flex items-start justify-between gap-3">
          <div className="min-w-0">
            {title != null ? (
              <h3 className="text-xs font-medium text-muted-foreground">
                {title}
              </h3>
            ) : null}
            {subtitle != null ? (
              <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p>
            ) : null}
          </div>
          {actions != null ? (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          ) : null}
        </div>
      ) : null}
      {children}
    </div>
  );
};
